<form novalidate #propertyAboutSectionForm="ngForm">
    <tg-input-container
        class="hide-optional-label"
        label="About this property"
        showRemainingCharacters
        *ngIf="draftLoaded$ | async"
    >
        <textarea
            tgTextInput
            name="description"
            rows="15"
            type="text"
            (blur)="publish()"
            placeholder="Provide as many details as you can (e.g. heating and insulation, flooring, sunlight, renovations, etc.)"
            [(ngModel)]="draftData.propertyDescription.description"
            [validation]="
                validation.propertyDescription.description | toValidator
            "
        ></textarea>
    </tg-input-container>
</form>
